import { render, staticRenderFns } from "./ContractPremiumInvoiceList.vue?vue&type=template&id=66471e02"
import script from "./ContractPremiumInvoiceList.vue?vue&type=script&lang=js"
export * from "./ContractPremiumInvoiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports